// ADMIN
export const REACT_SELECT_CUSTOM_STYLE = {
  control: (styles) => ({
    ...styles,
    borderTopWidth: '0',
    borderRightWidth: '0',
    borderLeftWidth: '0',
    borderBottomWidth: '1px',
    borderRadius: '0px',
    boxShadow: 'none',
  }),
}
export const REACT_SELECT_CUSTOM_STYLE_MERCHANT = {
  control: (styles) => ({
    ...styles,
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderLeftWidth: '1px',
    borderBottomWidth: '1px',
    borderRadius: '4px',
    boxShadow: 'none',
  }),
  indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
}

export const ADMIN_FORM_LABEL = 'uppercase block text-xs font-normal '
export const FORM_INPUT_CLASS =
  'shadow-sm appearance-none border-b w-full text-sm text-black pb-1 leading-tight focus:outline-none focus:border-b-2'

// MERCHANT
export const MERCHANT_FORM_LABEL = 'block tracking-wide text-primary-black text-sm font-bold'
export const MERCHANT_INPUT_CLASS =
  'appearance-none bg-white block w-full text-gray-700 border rounded-md py-2 px-4 leading-tight'

// SHARED
export const FORM_ERROR_CLASS = 'text-red-500 text-xs italic'
export const INPUT_ERROR_CLASS = 'border-red-500 leading-tight'
